<template>
  <div v-if="unavailable" class="offline-support-banner" role="alert">
    <font-awesome-icon icon="fa-light fa-circle-exclamation" class="mr-2"></font-awesome-icon>
    {{ t('general.offline_unsupported') }}
  </div>
</template>

<script setup>
// Warns the agent when the service worker cannot run in this browser, because the app then has no
// offline support at all: saves made without signal reach nobody, and a reload offline fails.
// Registration happens on the window's load event, after this mounts, so a failure arrives as an event.
import { onBeforeUnmount, ref } from 'vue'
import { offlineSupportAvailable } from '@/helpers/offlineSupport.js'
import { useI18nUtils } from '@/composables/utils/useI18nUtils.js'

const { t } = useI18nUtils()
const unavailable = ref(!offlineSupportAvailable())

function onRegistrationFailed() {
  unavailable.value = true
}

window.addEventListener('service-worker-registration-failed', onRegistrationFailed)
onBeforeUnmount(() => window.removeEventListener('service-worker-registration-failed', onRegistrationFailed))
</script>

<style scoped>
.offline-support-banner {
  position: sticky;
  top: 0;
  z-index: 1100;
  padding: 0.75rem 1rem;
  background-color: #ff7858;
  color: #ffffff;
  font-size: 14px;
  line-height: 1.4;
}
</style>
